import React, { useState, useCallback } from 'react';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import Button from '@material-ui/core/Button';
import { useStyles } from './styles';
import debounce from 'lodash/debounce';

const DIRECTION_OPTIONS = [
  { value: '', label: 'All' },
  { value: 'outbound', label: 'Outbound' },
  { value: 'inbound', label: 'Inbound' },
];

const FLOW_TYPE_OPTIONS = [
  { value: '', label: 'All' },
  { value: 'GRN', label: 'GRN' },
  { value: 'IBD', label: 'IBD' },
  { value: 'ASN', label: 'ASN' },
  { value: 'PO_SYNC', label: 'PO_SYNC' },
  { value: 'DS_SYNC', label: 'DS_SYNC' },
  { value: 'ALLOCATION', label: 'ALLOCATION' },
  { value: 'INVENTORY', label: 'INVENTORY' },
  { value: 'ASL_SYNC', label: 'ASL_SYNC' },
  { value: 'INSPECTION_LOTS', label: 'INSPECTION_LOTS' },
  { value: 'PO_CONFIRMATION', label: 'PO_CONFIRMATION' },
  { value: 'STO_OBD', label: 'STO_OBD' },
  { value: 'IDOC_PO_ACK', label: 'IDOC_PO_ACK' },
  { value: 'IDOC_ASN', label: 'IDOC_ASN' },
  { value: 'IDOC_PO_PUSH', label: 'IDOC_PO_PUSH' },
  { value: 'UNKNOWN', label: 'UNKNOWN' },
];

const STATUS_OPTIONS = [
  { value: '', label: 'All' },
  { value: 'success', label: 'Success' },
  { value: 'error', label: 'Error' },
  { value: 'timeout', label: 'Timeout' },
  { value: 'archived', label: 'Archived' },
  { value: 'parse_failed', label: 'Parse Failed' },
];

const FilterBar = ({ filters, onFilterChange, onReset, loading }) => {
  const classes = useStyles();

  const [searchInput, setSearchInput] = useState(filters.search || '');

  const debouncedSearch = useCallback(
    debounce((value) => {
      onFilterChange({ search: value });
    }, 300),
    [onFilterChange]
  );

  const handleSearchChange = (e) => {
    setSearchInput(e.target.value);
    debouncedSearch(e.target.value);
  };

  const handleSelectChange = (field) => (e) => {
    const value = e.target.value || null;
    onFilterChange({ [field]: value });
  };

  const handleDateChange = (field) => (e) => {
    const value = e.target.value || null;
    onFilterChange({ [field]: value });
  };

  const handleReset = () => {
    setSearchInput('');
    onReset();
  };

  return (
    <div className={classes.filterBar}>
      <TextField
        label='Date From'
        type='date'
        size='small'
        variant='outlined'
        value={filters.dateFrom || ''}
        onChange={handleDateChange('dateFrom')}
        InputLabelProps={{ shrink: true }}
        className={classes.filterItem}
        disabled={loading}
      />
      <TextField
        label='Date To'
        type='date'
        size='small'
        variant='outlined'
        value={filters.dateTo || ''}
        onChange={handleDateChange('dateTo')}
        InputLabelProps={{ shrink: true }}
        className={classes.filterItem}
        disabled={loading}
      />
      <TextField
        select
        label='Direction'
        size='small'
        variant='outlined'
        value={filters.direction || ''}
        onChange={handleSelectChange('direction')}
        className={classes.filterItem}
        disabled={loading}
      >
        {DIRECTION_OPTIONS.map((o) => (
          <MenuItem key={o.value} value={o.value}>
            {o.label}
          </MenuItem>
        ))}
      </TextField>
      <TextField
        select
        label='Flow Type'
        size='small'
        variant='outlined'
        value={filters.flowType || ''}
        onChange={handleSelectChange('flowType')}
        className={classes.filterItem}
        disabled={loading}
      >
        {FLOW_TYPE_OPTIONS.map((o) => (
          <MenuItem key={o.value} value={o.value}>
            {o.label}
          </MenuItem>
        ))}
      </TextField>
      <TextField
        select
        label='Status'
        size='small'
        variant='outlined'
        value={filters.status || ''}
        onChange={handleSelectChange('status')}
        className={classes.filterItem}
        disabled={loading}
      >
        {STATUS_OPTIONS.map((o) => (
          <MenuItem key={o.value} value={o.value}>
            {o.label}
          </MenuItem>
        ))}
      </TextField>
      <TextField
        label='Search'
        size='small'
        variant='outlined'
        placeholder='correlation ID or error...'
        value={searchInput}
        onChange={handleSearchChange}
        className={classes.filterItem}
        disabled={loading}
      />
      <Button
        variant='outlined'
        onClick={handleReset}
        disabled={loading}
        className={classes.resetButton}
      >
        Reset Filters
      </Button>
    </div>
  );
};

export default FilterBar;
